import { AppRoutes } from '../../app.app-manager-routes';
import { EntityManagerInfo } from '../../models/entity-config';

// Censimento delle voci del modulo servizi: solo dati, nessuna EMC (spec 2026-10-19 §5).
// Generato da tools/split-app-manager-routes.mjs; le EMC stanno nel data delle rotte e nelle EMC che aprono le modali.
export class ServiziRoutes {
  static readonly AllCertList: EntityManagerInfo = {
    id: 'AllCertList',
    name: 'allcertlist',
    translateSuffixs: ['generic.', 'allcert.'],
    url: 'allcertlist',
    parent: AppRoutes.Servizi
  };

  static readonly AllCertEdit: EntityManagerInfo = {
    id: 'AllCertEdit',
    name: 'allcertedit',
    translateSuffixs: ['generic.', 'allcert.'],
    url: 'allcertedit',
    parent: ServiziRoutes.AllCertList
  };
}
